import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import logo from '../assets/logo.png';

const Hero: React.FC = () => {
  const scrollToProducts = () => {
    const el = document.getElementById('catalogue');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <Box
      component="section"
      sx={{
        position: 'relative',
        width: '100%',
        minHeight: { xs: '78vh', md: '88vh' },
        display: 'flex',
        alignItems: 'flex-end',
        overflow: 'hidden',
        color: '#fff',
      }}
    >
      <Box
        component="img"
        src="/images/banner-quiche.jpg"
        alt="Quiche Hello Gassy'z"
        sx={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          animation: 'hg-fade-in 1.1s ease both',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background:
            'linear-gradient(180deg, rgba(26,20,18,0.15) 0%, rgba(26,20,18,0.35) 40%, rgba(26,20,18,0.82) 100%)',
        }}
      />

      <Box
        sx={{
          position: 'relative',
          zIndex: 1,
          width: '100%',
          maxWidth: 1100,
          mx: 'auto',
          px: { xs: 2.5, md: 4 },
          pb: { xs: 5, md: 8 },
          pt: { xs: 14, md: 10 },
        }}
      >
        <Box
          className="hg-fade-up"
          component="img"
          src={logo}
          alt="Hello Gassy'z"
          sx={{
            height: { xs: 72, md: 110 },
            width: 'auto',
            mb: 2,
            filter: 'drop-shadow(0 8px 24px rgba(0,0,0,0.35))',
          }}
        />
        <Typography
          className="hg-fade-up-delay"
          variant="h2"
          sx={{
            fontSize: { xs: '2rem', sm: '2.75rem', md: '3.5rem' },
            lineHeight: 1.1,
            maxWidth: 640,
            mb: 1.5,
            color: '#fff',
            textShadow: '0 2px 24px rgba(0,0,0,0.35)',
          }}
        >
          Hello Gassy&apos;z
        </Typography>
        <Typography
          className="hg-fade-up-delay"
          sx={{
            fontSize: { xs: '1rem', md: '1.2rem' },
            maxWidth: 460,
            mb: 3,
            color: 'rgba(255,255,255,0.9)',
            fontWeight: 400,
          }}
        >
          Votre fournisseur de pâtes — fraîches, généreuses, prêtes à garnir.
        </Typography>
        <Button
          className="hg-fade-up-delay-2"
          variant="contained"
          size="large"
          onClick={scrollToProducts}
          sx={{
            backgroundColor: '#E31E24',
            px: 4,
            py: 1.4,
            fontSize: '1rem',
            '&:hover': {
              backgroundColor: '#b8161b',
              transform: 'translateY(-2px)',
            },
            transition: 'transform 0.25s ease, background-color 0.25s ease',
          }}
        >
          Commander
        </Button>
      </Box>
    </Box>
  );
};

export default Hero;
